<template>
  <div
    v-tooltip="props.collapsed ? name : ''"
    class="group flex max-h-[51px] w-fit cursor-pointer items-center
    border-l-4 transition-colors duration-150"
    :class="{
      'border-l-[--v3-theme-primarycolor] bg-[--v3-theme-primarycolor] text-[--v3-theme-primarytextcolor] hover:border-l-[--v3-theme-primarydarkestcolor] hover:bg-[--v3-theme-primarydarkercolor] hover:text-[--v3-theme-primarytextcolor]': !props.active,
      'border-l-[--v3-theme-primarydarkestcolor] bg-[--v3-theme-primarydarkercolor] text-[--v3-theme-primarytextcolor] hover:bg-[--v3-theme-primarydarkestcolor] hover:text-[--v3-theme-primarytextcolor]': props.active,
    }"
  >
    <div v-if="icon" class="flex h-[51px] w-[46px] items-center justify-center">
      <Icon
        class="ml-[-4px] size-full"
        :class="{
          'text-[--v3-theme-primarytextcolor]': props.active,
        }"
        :name="props.icon"
        :height="16"
        :width="16"
      />
    </div>
    <div
      class="flex h-[21px] translate-x-[-3px] select-none items-center justify-between transition-[width]"
      :class="{
        'w-[227px] pr-[15px]': !props.collapsed,
        'w-0 pr-0': props.collapsed,
      }"
    >
      <span
        class="link-name font-bold leading-[21px] transition-[font-size,opacity]"
        :class="{
          'text-[14px] opacity-100': !props.collapsed,
          'text-[0] opacity-0': props.collapsed,
        }"
      >
        {{ name }}
      </span>
      <div
        v-if="!props.collapsed"
        class="flex size-[12px] items-center justify-center text-[--v3-blue-gray-bluegray-400]"
      >
        <Icon :name="props.active? 'angle-up': 'angle-down'" class="size-full" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Icon from '@/common/components/atoms/Icon';

const props = withDefaults(defineProps<{
  name: string,
  icon: string,
  active?: boolean,
  collapsed?: boolean,
}>(), {
  active: false,
  collapsed: false,
});
</script>

<style lang="scss" scoped>
.link-name {
  font-family: Roboto,serif;
}
</style>
